var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41176 0C0.632 0 0 0.695718 0 1.55294V8.8C0 9.65723 0.632 10.3529 1.41176 10.3529C2.19153 10.3529 2.82353 9.65723 2.82353 8.8V1.55294C2.82353 0.695718 2.19153 0 1.41176 0Z",
    fill: "#0090C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2353 0C6.45553 0 5.82353 0.695718 5.82353 1.55294V8.8C5.82353 9.65722 6.45553 10.3529 7.2353 10.3529C8.01506 10.3529 8.64706 9.65722 8.64706 8.8V1.55294C8.64706 0.695718 8.01506 0 7.2353 0Z",
    fill: "#0090C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPause);
export default __webpack_public_path__ + "static/media/icon-pause.493fc7231e59279685aaad889f171f08.svg";
export { ForwardRef as ReactComponent };